
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.369 12.139a.554.554 0 00-.53-.385H8.484l-.425-1.296a.554.554 0 00-1.056 0l-.425 1.298H5.24a.554.554 0 00-.326 1.006l1.095.792-.427 1.28a.554.554 0 00.854.627l1.094-.792 1.1.797a.554.554 0 00.856-.621l-.417-1.289 1.097-.794a.555.555 0 00.203-.623zm-1.903.874a.554.554 0 00-.203.623l.247.764-.654-.475a.555.555 0 00-.652 0l-.64.462.25-.75a.554.554 0 00-.201-.625l-.646-.464h.781a.554.554 0 00.528-.383l.255-.775.254.776a.554.554 0 00.528.382h.8l-.647.465z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14.43.656A.395.395 0 0014.132 0H10.49a.396.396 0 00-.298.136L5.368 5.67l.003.003a.391.391 0 00-.1.257v1.459a6.02 6.02 0 104.433 0v-1.31L14.43.655zm-3.76.136h2.592L9.129 5.534H6.536L10.67.792zm2.046 12.188a5.228 5.228 0 11-10.456 0 5.228 5.228 0 0110.456 0zM7.488 6.96c-.48.002-.96.062-1.425.178v-.812h2.85v.812a6.005 6.005 0 00-1.425-.178zM5.386 4.948L1.742.792h2.6l2.362 2.454.57-.55L4.796.122A.396.396 0 004.511 0H.87a.396.396 0 00-.297.657L4.79 5.469l.595-.521z","fill":"#fff"}})])
          )
        }
      }
    